import { Component, OnInit, Injector } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { SecondPageEditBase, UserService } from 'vnpost-shared';
import { CategoryService } from '../../services/category.service';
import { CommissionsForSaleService } from '../../services/commissions-for-sale.service';
import { StaffManagerService } from '../../services/staff-manager.service';

@Component({
  selector: 'app-edit-staff-manager',
  templateUrl: './edit-staff-manager.component.html',
  styleUrls: ['./edit-staff-manager.component.css'],
})
export class EditStaffManagerComponent
  extends SecondPageEditBase
  implements OnInit
{
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang áp dụng', value: 1 },
    { label: 'Ngừng áp dụng', value: 0 },
  ];
  listManager: { label: string; value: string }[] = [];
  listSalesChannel: { label: string; value: number }[] = [];
  currentUnitCode: any;

  constructor(
    protected _staffManagerService: StaffManagerService,
    protected _saleChannelService: CommissionsForSaleService,
    protected _injector: Injector,
    protected _userService: UserService
  ) {
    super(_userService, _injector);
    this.currentUnitCode = this.currentUser?.unitCode;
    this.formGroup = new UntypedFormGroup({
      employeeCode: new UntypedFormControl('', [Validators.required]),
      employeeName: new UntypedFormControl('', [Validators.required]),
      unitName: new UntypedFormControl('', [Validators.required]),
      provinceName: new UntypedFormControl('', [Validators.required]),
      jobTitleName: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl(''),
      managerId: new UntypedFormControl(0, [Validators.required]),
      salesChannelId: new UntypedFormControl('', [Validators.required]),
      notes: new UntypedFormControl(''),
    });
  }

  ngOnInit() {
    this.loadSaleChannel();
  }
  loadSaleChannel() {
    this._saleChannelService
      .getAllByUnitCode(this.currentUnitCode)
      .then((rs) => {
        if (rs) {
          this.listSalesChannel = rs?.data?.map((r) => ({
            label: `${r.name}`,
            value: r.id,
          }));
        }
      });
  }
  loadUserManager() {
    this._staffManagerService
      .getListManager(this.itemDetail.employeeCode)
      .then((rs) => {
        if (rs) {
          this.listManager = rs?.data?.map((r) => ({
            label: `${r.name}-(${r.id})`,
            value: r.id,
          }));
          this.listManager.unshift({ label: 'Tất cả', value: '0' });
        }
      });
  }
  onShowPopup(model: any) {
    this.validationSummary.resetErrorMessages();
    this.resetForm();

    if (model.employeeCode > 0) {
      this._staffManagerService.getStaffManagerDetail(model.employeeCode).then(
        (rs) => {
          this.itemDetail = rs.data;
          this.loadUserManager();
        },
        (error) => {
          this._notifierService.showWarning(
            this._translateService.instant('MESSAGE.NOT_FOUND_ERROR')
          );
        }
      );
    }
  }

  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }

    this.onUpdate();
  }

  onUpdate() {
    this._staffManagerService
      .update(this.itemDetail.employeeCode, this.itemDetail)
      .then(
        (response) => {
          this.closePopupMethod(true);
          this._notifierService.showUpdateDataSuccess();
          this.onAfterSave();
          this.submitting = false;
        },
        (error) => {
          this._notifierService.showUpdateDataFailed();
          this.submitting = false;
        }
      );
  }
}
